// posthog-js and other libs reference `process` at runtime in browser bundles;
// Bun replaces BUN_PUBLIC_* vars but doesn't polyfill the `process` global itself.
if (typeof globalThis.process === 'undefined') {
  ;(globalThis as { process: { env: { NODE_ENV: string } } }).process = {
    env: { NODE_ENV: 'production' },
  }
}

if (typeof crypto.randomUUID !== 'function') {
  crypto.randomUUID = () =>
    '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => {
      const n = Number(c)
      return (
        n ^
        (crypto.getRandomValues(new Uint8Array(1))[0]! & (15 >> (n / 4)))
      ).toString(16)
    }) as ReturnType<typeof crypto.randomUUID>
}
